import { createFileRoute } from '@tanstack/react-router';

import { BillingPanel } from '../../../features/billing/BillingPanel';

/** Spec 11.3: "Plan, renewal date, credits used/remaining, ledger, portal link." */
export const Route = createFileRoute('/$lang/studio/billing')({ component: Page });

function Page(): React.ReactNode {
  /* A facilitator's leading figure is facilitated sessions; the panel is otherwise shared. */
  return <BillingPanel lead="facilitated" />;
}
